<template>
  <div>
    <div class="flexwrap" style="justify-content: flex-end; height: 100%">
      <div id="dashBoardMenu-body">
        <div class="normalLink">
          <router-link :to="{name: 'profile'}">
            <div class="menuItem flexwrap" :class="$route.name=='profile'?'menuItemselected':''">
              <i class="far fa-id-card"></i>
              <span>Mon profil</span>
            </div>

          </router-link>
        </div>
        <div class="normalLink">
          <router-link :to="{name: 'english-level'}">
            <div class="menuItem flexwrap" :class="$route.name=='english-level'?'menuItemselected':''">
              <i class="fa-regular fa-line-height"></i>
              <span>Mon niveau</span>
            </div>
          </router-link>
        </div>
        <div class="normalLink">
          <router-link :to="{name: 'catalog'}">
            <div class="menuItem flexwrap" :class="$route.name=='catalog'?'menuItemselected':''">
              <i class="fa-solid fa-grid-2-plus"></i>
              <span>Ma série</span>
            </div>
          </router-link>
        </div>
        <div class="normalLink">
          <router-link :to="{name: 'goal'}">
            <div class="menuItem flexwrap" :class="$route.name=='goal'?'menuItemselected':''">
              <i class="fa-regular fa-calendar-days"></i>
              <span>Mon objectif</span>
            </div>
          </router-link>
        </div>
        <!--
        <div class="normalLink">
          <router-link :to="{name: 'premium'}">
            <div class="menuItem flexwrap" :class="$route.name=='premium'?'menuItemselected':''">
              <i class="fa-solid fa-fire-flame-simple"></i>
              <span v-if="profile.datas.is_premium">Mon abonnement</span>
              <span v-else>Progresser plus vite</span>
            </div>
          </router-link>
        </div>
        -->
        <div></div>
        <div></div>
        <div>
          <div class="menuItem flexwrap clickable" @click="logout">
            <i class="fa-solid fa-arrow-right-from-bracket"></i>
            <span>Se déconnecter</span>
          </div>

        </div>


      </div>
    </div>
  </div>


</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "dashboardMenu",

  computed: {
    ...mapGetters('global', [
      'isMobile',
      'routeName',
      'profile',
    ]),
  },

  watch: {
    'routeName': function () {
      this.$emit('mobileMenuNavClicked')
    }
  },
  methods: {
    logout() {
      this.$webAuth.logout({
        returnTo: window.location.origin
      });

    },
  }
}
</script>

<style scoped>
#dashBoardMenu-body {
  height: calc(90% - 4vw);
  width: calc(100% - 4vw);
  align-content: flex-start;
  background-color: hsla(220, 60%, 70%, 0.09);
  display: grid;
  margin: 2vw;
  border-radius: 1vw;
  grid-template-rows: repeat(5, auto) 1fr auto;
  overflow: hidden;
}

#dashBoardMenu-body > * {
  width: 100%;
}

.menuItem {
  width: calc(100% - 2vw);
  height: min-content;
  font-size: 1.2vw;
  align-content: center;
  align-items: center;
  justify-self: flex-end;
  display: grid;
  grid-template-columns: 2.5vw auto 1fr;
  justify-items: center;
  padding: 1vw;
}

.menuItem:hover {
  background-color: #ffffff11;
}

.menuItemselected {
  background-color: var(--goalBackgroundColor);
  /*border-left: 0.5vw solid var(--goalBackgroundColor2);
  padding-left: 0.5vw;*/
}

.menuItemselected:hover {
  background-color: var(--goalBackgroundColor);
}

@media screen and (max-device-width: 767px) {
  #dashBoardMenu-body {
    width: 100vw;
    height: 70vh;
    font-size: 5vw;
    border-radius: 4vw;
    background-color: var(--navBackgroundColor);
  }

  .menuItem {
    width: calc(100% - 10vw);
    height: min-content;
    font-size: 1.2vw;
    align-content: center;
    align-items: center;
    justify-self: flex-end;
    display: grid;
    grid-template-columns: 10vw auto 1fr;
    justify-items: center;
    padding: 5vw;
  }


  .menuItem {
    font-size: 5vw;
  }
}

</style>
